<template>
  <div>
    <div v-if="!hasChildren" class="">

            <!-- HEAD -->

            <div class="head row p-0 g-0">
                <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 p-0"  data-aos="fade-right" data-aos-duration="500">
                    <img :src="`${publicPath}img/01avanzando.jpg`" class="img-responsive">
                </div>
                <div class="headRight py-3 py-md-0 py-xl-5" data-aos="fade-right" data-aos-delay="400" data-aos-duration="200">
                    <h1 class="my-3 my-lg-0 my-xl-3 my-xxl-5">01</h1>
                    <h2 class="my-3 my-lg-0 my-xl-3">{{ $t('futuro.avanzando-hacia-el-futuro') }} </h2>
                    <p class="text-end pt-2 pt-md-3 pt-xl-3">{{ $t('futuro.estrategia-de-largo-plazo-basada-en-el-crecimiento-y-el-desarrollo-sostenible') }}</p>
                </div>
            </div>

            <!-- end HEAD -->

            <div class="contingut bg-white row g-0">
                <div class="col-12 mt-5 pt-5">
                    <h2 class="mb-5" data-aos="fade" data-aos-duration="1500">{{ $t('futuro.seis-pilares-estrategicos') }}</h2>
                    <p class="text-turquesa px-1 mx-0 px-md-5 mx-lg-5" data-aos="fade-left" data-aos-duration="1000">{{ $t('futuro.los-seis-pilares-senalan') }}</p>
                </div>
            </div>


            <div class="contingut bg-white row g-0 ">

                    <div class="col-12 pb-5 position-relative">
                        <div class="row align-items-top">

                            <div class="col-12 col-md-6 col-lg-4 avanzandoIco" data-aos="fade-right" data-aos-delay="500"
                                 data-aos-easing="ease-out-cubic"
                                 data-aos-duration="2000" data-bs-toggle="collapse" href="#collapse01" role="button" aria-expanded="false" aria-controls="collapse01">
                                    <img :src="`${publicPath}img/01avCrecimiento.png`" class="img-responsive">
                                    <h4 class="text-blau py-3">{{ $t('futuro.crecimiento') }}</h4>
                            </div>
                            <div class="blocCollapseR">
                                <div class="collapse collapseR" id="collapse01">
                                    <div class="card card-body txtCollapse icoCollapse">
                                        <div class="row align-items-center">
                                            <div class="col-12">
                                                <div class="zonaCollapse pt-2">
                                                    <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse01" role="button" aria-expanded="false" aria-controls="collapse01"><i class="fa-solid fa-xmark"></i></a>
                                                </div>
                                            </div>
                                            <div class="col-10 m-auto py-5 px-0 px-lg-5">
                                                <localized-link to="/avanzando-hacia-el-futuro/crecimiento">
                                                    <img :src="`${publicPath}img/01avCrecimiento.png`" class="img-responsive">
                                                </localized-link>
                                                <h4 class="text-blau py-3">{{ $t('futuro.crecimiento') }}</h4>
                                                <p class="text-blau2">{{ $t('futuro.crecimiento-txt') }}</p>
                                                <p>&nbsp;</p>
                                                <localized-link to="/avanzando-hacia-el-futuro/crecimiento" class="btnCollapseIn btnFosc"><i class="fa-solid fa-plus"></i></localized-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 col-lg-4 avanzandoIco" data-aos="fade-up"
                                 data-aos-easing="ease-out-cubic"
                                 data-aos-duration="2000" data-bs-toggle="collapse" href="#collapse02" role="button" aria-expanded="false" aria-controls="collapse02">
                                <img :src="`${publicPath}img/01avExcelencia.png`" class="img-responsive">
                                <h4 class="text-blau py-3">{{ $t('futuro.excelencia-operacional') }}</h4>
                            </div>
                            <div class="blocCollapseR">
                                <div class="collapse collapseR" id="collapse02">
                                    <div class="card card-body txtCollapse icoCollapse">
                                        <div class="row align-items-center">
                                            <div class="col-12">
                                                <div class="zonaCollapse pt-2">
                                                    <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse02" role="button" aria-expanded="false" aria-controls="collapse02"><i class="fa-solid fa-xmark"></i></a>
                                                </div>
                                            </div>
                                            <div class="col-10 m-auto py-5 px-0 px-lg-5">
                                                <localized-link to="/avanzando-hacia-el-futuro/excelencia-operacional">
                                                    <img :src="`${publicPath}img/01avExcelencia.png`" class="img-responsive">
                                                </localized-link>
                                                <h4 class="text-blau py-3">{{ $t('futuro.excelencia-operacional') }}</h4>
                                                <p class="text-blau2">{{ $t('futuro.experiencia-txt') }}</p>
                                                <p>&nbsp;</p>
                                                <localized-link to="/avanzando-hacia-el-futuro/excelencia-operacional" class="btnCollapseIn btnFosc"><i class="fa-solid fa-plus"></i></localized-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 col-lg-4 avanzandoIco" data-aos="fade-left" data-aos-delay="500"
                                 data-aos-easing="ease-out-cubic"
                                 data-aos-duration="2000" data-bs-toggle="collapse" href="#collapse03" role="button" aria-expanded="false" aria-controls="collapse03">
                                <img :src="`${publicPath}img/01avInnovacion.png`" class="img-responsive">
                                <h4 class="text-blau py-3">{{ $t('futuro.innovacion') }}</h4>
                            </div>
                            <div class="blocCollapseR">
                                <div class="collapse collapseR" id="collapse03">
                                <div class="card card-body txtCollapse icoCollapse">
                                    <div class="row align-items-center">
                                        <div class="col-12">
                                            <div class="zonaCollapse pt-2">
                                                <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse03" role="button" aria-expanded="false" aria-controls="collapse03"><i class="fa-solid fa-xmark"></i></a>
                                            </div>
                                        </div>
                                        <div class="col-10 m-auto py-5 px-0 px-lg-55">
                                            <localized-link to="/avanzando-hacia-el-futuro/innovacion">
                                                <img :src="`${publicPath}img/01avInnovacion.png`" class="img-responsive">
                                            </localized-link>
                                            <h4 class="text-blau py-3">{{ $t('futuro.innovacion') }}</h4>
                                            <p class="text-blau2">{{ $t('futuro.innovacion-txt') }}</p>
                                            <p>&nbsp;</p>
                                            <localized-link to="/avanzando-hacia-el-futuro/innovacion" class="btnCollapseIn btnFosc"><i class="fa-solid fa-plus"></i></localized-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                            <div class="col-12 col-md-6 col-lg-4 avanzandoIco" data-aos="fade-right" data-aos-delay="1500"
                                 data-aos-easing="ease-out-cubic"
                                 data-aos-duration="1000" data-bs-toggle="collapse" href="#collapse04" role="button" aria-expanded="false" aria-controls="collapse04">
                                <img :src="`${publicPath}img/01avPersonas.png`" class="img-responsive">
                                <h4 class="text-blau py-3">{{ $t('futuro.transformacion-digital') }}</h4>
                            </div>
                            <div class="blocCollapseR">
                                <div class="collapse collapseR" id="collapse04">
                                    <div class="card card-body txtCollapse icoCollapse">
                                        <div class="row align-items-center">
                                            <div class="col-12">
                                                <div class="zonaCollapse pt-2">
                                                    <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse04" role="button" aria-expanded="false" aria-controls="collapse04"><i class="fa-solid fa-xmark"></i></a>
                                                </div>
                                            </div>
                                            <div class="col-10 m-auto py-5 px-0 px-lg-5">
                                                <localized-link to="/avanzando-hacia-el-futuro/transformacion-digital">
                                                    <img :src="`${publicPath}img/01avPersonas.png`" class="img-responsive">
                                                </localized-link>
                                                <h4 class="text-blau py-3">{{ $t('futuro.transformacion-digital') }}</h4>
                                                <p class="text-blau2">{{ $t('futuro.transformacion-txt') }}</p>
                                                <p>&nbsp;</p>
                                                <localized-link to="/avanzando-hacia-el-futuro/transformacion-digital" class="btnCollapseIn btnFosc"><i class="fa-solid fa-plus"></i></localized-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 col-lg-4 avanzandoIco" data-aos="fade-up" data-aos-delay="1000"
                                 data-aos-easing="ease-out-cubic"
                                 data-aos-duration="1000" data-bs-toggle="collapse" href="#collapse05" role="button" aria-expanded="false" aria-controls="collapse05">
                                <img :src="`${publicPath}img/01avSostenibilidad.png`" class="img-responsive">
                                <h4 class="text-blau py-3">{{ $t('futuro.sostenibilidad') }}</h4>
                            </div>
                            <div class="blocCollapseR">
                                <div class="collapse collapseR" id="collapse05">
                                    <div class="card card-body txtCollapse icoCollapse">
                                        <div class="row align-items-center">
                                            <div class="col-12">
                                                <div class="zonaCollapse pt-2">
                                                    <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse05" role="button" aria-expanded="false" aria-controls="collapse05"><i class="fa-solid fa-xmark"></i></a>
                                                </div>
                                            </div>
                                            <div class="col-10 m-auto py-5 px-0 px-lg-5">
                                                <localized-link to="/avanzando-hacia-el-futuro/sostenibilidad">
                                                    <img :src="`${publicPath}img/01avSostenibilidad.png`" class="img-responsive">
                                                </localized-link>
                                                <h4 class="text-blau py-3">{{ $t('futuro.sostenibilidad') }}</h4>
                                                <p class="text-blau2">{{ $t('futuro.sostenibilidad-txt') }}</p>
                                                <p>&nbsp;</p>
                                                <localized-link to="/avanzando-hacia-el-futuro/sostenibilidad" class="btnCollapseIn btnFosc"><i class="fa-solid fa-plus"></i></localized-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 col-lg-4 avanzandoIco" data-aos="fade-left" data-aos-delay="1500"
                                 data-aos-easing="ease-out-cubic"
                                 data-aos-duration="1000" data-bs-toggle="collapse" href="#collapse06" role="button" aria-expanded="false" aria-controls="collapse06">
                                <img :src="`${publicPath}img/01avTransformacion.png`" class="img-responsive">
                                <h4 class="text-blau py-3">{{ $t('futuro.personas') }}</h4>
                            </div>
                            <div class="blocCollapseR">
                                <div class="collapse collapseR" id="collapse06">
                                    <div class="card card-body txtCollapse icoCollapse">
                                        <div class="row align-items-center">
                                            <div class="col-12">
                                                <div class="zonaCollapse pt-2">
                                                    <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse06" role="button" aria-expanded="false" aria-controls="collapse06"><i class="fa-solid fa-xmark"></i></a>
                                                </div>
                                            </div>
                                            <div class="col-10 m-auto py-5 px-0 px-lg-5">
                                                <localized-link to="/avanzando-hacia-el-futuro/personas">
                                                    <img :src="`${publicPath}img/01avTransformacion.png`" class="img-responsive">
                                                </localized-link>
                                                <h4 class="text-blau py-3">{{ $t('futuro.personas') }}</h4>
                                                <p class="text-blau2">{{ $t('futuro.personas-txt') }}</p>
                                                <p>&nbsp;</p>
                                                <localized-link to="/avanzando-hacia-el-futuro/personas" class="btnCollapseIn btnFosc"><i class="fa-solid fa-plus"></i></localized-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

            </div>

            <div class="contingut bg-darkBlue row g-0">
                <div class="col-12 col-lg-10 m-auto my-5 py-0 py-lg-5">
                    <h3 class="pb-3 text-turquesa">{{ $t('futuro.para-lograr-un-triple-impacto') }}</h3>
                    <h4 class="text-white pb-0 pb-lg-5 mb-5 px-1 mx-0 px-md-5 mx-lg-5" data-aos="fade-left" data-aos-duration="1000">{{ $t('futuro.el-compromiso-corporativo-con-la-sostenibilidad-persigue-la-generacion-de-impacto-positivo-en-tres-grandes-ambitos-personas-planeta-y-prosperidad') }}</h4>

                    <div class="row">
                        <div class="col-12 col-lg-4 px-1 px-sm-5 px-lg-3 px-xl-4 px-xxl-5 py-3 py-lg-0"  data-aos="fade-right" data-aos-duration="1000">
                            <h4 class="text-turquesa text-center text-lg-start pb-2">{{ $t('futuro.personas') }}</h4>
                            <p class="text-white text-center text-lg-start">{{ $t('futuro.impacto-1') }}</p>
                        </div>
                        <div class="col-12 col-lg-4 px-1 px-sm-5 px-lg-3 px-xl-4 px-xxl-5 py-3 py-lg-0" data-aos="fade-up" data-aos-duration="1000">
                            <h4 class="text-turquesa text-center text-lg-start pb-2">{{ $t('futuro.planeta') }}</h4>
                            <p class="text-white text-center text-lg-start">{{ $t('futuro.impacto-2') }}</p>
                        </div>
                        <div class="col-12 col-lg-4 px-1 px-sm-5 px-lg-3 px-xl-4 px-xxl-5 py-3 py-lg-0" data-aos="fade-left" data-aos-duration="1000">
                            <h4 class="text-turquesa text-center text-lg-start pb-2">{{ $t('futuro.prosperidad') }}</h4>
                            <p class="text-white text-center text-lg-start">{{ $t('futuro.impacto-3') }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="contingut bg-white row g-0 pb-5">
                <div class="col-12 my-5 py-5 fonsGris position-relative">
                    <div class="blocCollapseR">
                        <a class="btnCollapseIn btnFosc" data-bs-toggle="collapse" href="#collapse00" role="button" aria-expanded="false" aria-controls="collapse00"><i class="fa-solid fa-plus"></i></a>
                        <div class="collapse collapseR" id="collapse00">
                            <div class="card card-body txtCollapse">
                                <div class="row align-items-center">
                                    <div class="col-12">
                                        <div class="zonaCollapse">
                                            <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse00" role="button" aria-expanded="false" aria-controls="collapse00"><i class="fa-solid fa-xmark"></i></a>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-2">
                                        <img :src="`${publicPath}img/01crecimiento-logo_${locale}.gif`" class="img-responsive mx-auto mt-3 mt-sm-5 mt-md-5 mt-lg-0">
                                    </div>
                                    <div class="col-12 col-lg-9 py-3 px-3 px-lg-5 text-center text-lg-start text-white">
                                        <p>{{ $t('futuro.ods-txt') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <h4 class=" text-turquesa pb-3 mb-3">{{ $t('futuro.compromiso-con-el-desarrollo-sostenible') }}</h4>
                    <div class="row justify-content-center ods">
                        <div class="col-12 col-lg-6 col-xl-6 col-xxl-5">
                            <p class="float-none float-lg-start text-center text-lg-end" v-html="$t('futuro.ods-de-impacto')"></p>
                            <img :src="`${publicPath}img/01avanzando-icono01.gif`" class="img-responsive m-1" width="57">
                            <img :src="`${publicPath}img/01avanzando-icono02.gif`" class="img-responsive m-1" width="57">
                            <img :src="`${publicPath}img/01avanzando-icono03.gif`" class="img-responsive m-1" width="57">
                            <img :src="`${publicPath}img/01avanzando-icono04.gif`" class="img-responsive m-1" width="57">
                            <img :src="`${publicPath}img/01avanzando-icono05.gif`" class="img-responsive m-1" width="57">
                        </div>
                    </div>

                </div>

                <hr>
                <div class="row p-0 g-0">
                    <div class="col-12 p-3 p-lg-0 m-0 pb-3 text-end">
                        <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/crecimiento">{{ $t("nav.crecimiento") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
                    </div>
                </div>

            </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "AvanzandoHaciaElFuturoView",
    props: {
      hasChildren: Boolean
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            locale:this.$i18n.locale
        }
    }
  }
</script>

